module.exports = __webpack_public_path__ + "media/images/bet__bg--xcc-fdf023335123ab837a37bf716b440d0c.jpg";